export function formatDuration(totalSeconds) {
  const n = Number(totalSeconds);
  if (!isFinite(n) || n < 0) return "0 sec";

  // Break down
  let hrs = Math.floor(n / 3600);
  let rem = n - hrs * 3600;
  let mins = Math.floor(rem / 60);
  let secs = rem - mins * 60;

  // Round seconds to 2 decimals
  secs = Math.round(secs * 100) / 100;

  // Handle rollover (e.g., 59.999 -> 60.00)
  if (secs >= 60) {
    mins += 1;
    secs -= 60;
  }
  if (mins >= 60) {
    hrs += Math.floor(mins / 60);
    mins = mins % 60;
  }

  const parts = [];
  if (hrs > 0) parts.push(`${hrs} hr${hrs === 1 ? "" : "s"}`);
  if (mins > 0) parts.push(`${mins} min${mins === 1 ? "" : "s"}`);

  // show seconds only if > 0 OR nothing else to show
  if (secs > 0 || parts.length === 0) {
    const secsStr = Number.isInteger(secs)
      ? String(secs)
      : secs
          .toFixed(2)
          .replace(/\.00$/, "")
          .replace(/(\.\d)0$/, "$1");
    parts.push(`${secsStr} sec${secs === 1 ? "" : "s"}`);
  }

  return parts.join(" ");
}
